import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../pages/Home/Home'
import Observatoire from '../pages/Observatoire/Observatoire'
import DonneesEtSol from '../pages/DonneesEtSol/DonneesEtSol'
import Events from '../pages/events/Events'
import AproposPage from '../pages/Apropos/AproposPage'

const RoutesList = ({selectedEvent,
  setSelectedEvent,
  currentEvent,
  setCurrentEvent}) => {
  return (
    <Routes>
        <Route path='/' element={<Home setSelectedEvent={setSelectedEvent}
setCurrentEvent={setCurrentEvent} />}/>
        <Route path='/observatoire' element={<Observatoire />}/>
        <Route path='/donnessolution' element={<DonneesEtSol />}/>
        <Route path='/apropos' element={<AproposPage />}/>
        <Route path='/events' element={<Events selectedEvent={selectedEvent}
setSelectedEvent={setSelectedEvent}
currentEvent={currentEvent}
setCurrentEvent={setCurrentEvent} />}/>
    </Routes>
  )
}

export default RoutesList